import React, { useState } from 'react';
import configData from '../../config.json';
import { MARKETING_ADDITIONAL_PROGRAMS } from './marketingAdditionalProgramsCatalog';
import './MarketingAssets.css';

function programCoverUrl(coverPath) {
    if (!coverPath) {
        return '';
    }
    const base = configData.SERVER_URL_IMG || 'https://dashboard.oolalife.com/';
    const normalized = String(coverPath).replace(/^\//, '');
    const encoded = normalized
        .split('/')
        .map((segment) => encodeURIComponent(segment))
        .join('/');
    return `${base}${encoded}`;
}

function ProgramCoverImage({ program }) {
    const sources = [program.coverPath, program.coverFallbackPath].filter(Boolean);
    const [sourceIndex, setSourceIndex] = useState(0);
    const [failed, setFailed] = useState(false);

    if (!sources.length || failed) {
        return (
            <div className="marketing-program-covers__placeholder">
                <span>{program.title}</span>
            </div>
        );
    }

    return (
        <img
            src={programCoverUrl(sources[sourceIndex])}
            alt={program.title}
            loading="lazy"
            onError={() => {
                if (sourceIndex < sources.length - 1) {
                    setSourceIndex(sourceIndex + 1);
                } else {
                    setFailed(true);
                }
            }}
        />
    );
}

function CoverGrid({ programs, layout }) {
    if (!programs.length) {
        return null;
    }

    return (
        <div
            className={`marketing-program-covers__grid marketing-program-covers__grid--${layout}`}
        >
            {programs.map((program) => (
                <figure
                    key={program.title}
                    className="marketing-program-covers__item"
                >
                    <div
                        className={`marketing-program-covers__media marketing-program-covers__media--${layout}`}
                    >
                        <ProgramCoverImage program={program} />
                    </div>
                    <figcaption>{program.title}</figcaption>
                </figure>
            ))}
        </div>
    );
}

const programsWithCovers = MARKETING_ADDITIONAL_PROGRAMS.filter(
    (program) => program.coverPath
);
const portraitPrograms = programsWithCovers.filter(
    (program) => program.coverLayout !== 'landscape'
);
const landscapePrograms = programsWithCovers.filter(
    (program) => program.coverLayout === 'landscape'
);

/** Program covers — portrait shop cards + landscape wide covers, grouped separately. */
const MarketingAdditionalProgramsCoversPreview = () => (
    <div className="marketing-program-covers">
        <p className="marketing-program-covers__eyebrow">
            Optional add-ons · sold separately from the Framework
        </p>
        <CoverGrid programs={portraitPrograms} layout="portrait" />
        {landscapePrograms.length ? (
            <CoverGrid programs={landscapePrograms} layout="landscape" />
        ) : null}
    </div>
);

export default MarketingAdditionalProgramsCoversPreview;
